import React from "react";
import fb from '../../lib/firebase';
import FieldView from "../../components/FieldView";
import FormAnexo from "./FormAnexo";
import {formDef} from "./FormAnexo";
import EntityView from "../../components/EntityView";
import {AnexoObject} from "../../models/Anexo";
import {IonButton, IonProgressBar} from "@ionic/react";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import { Browser } from '@capacitor/browser';
import Lightbox from "react-image-lightbox";
import {debug} from "../../config";
import fetch from "isomorphic-fetch";
import has from "lodash/has";
import {dataInCurrentMonth} from "../../lib/utils";


interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: AnexoObject;
  goBack: () => void;
  loading: boolean;
}

interface State {
  anexoURL: string | undefined;
  loading: boolean;
  showModal: boolean;
  allowDelete: boolean;
}

class AbaAnexo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      anexoURL: undefined,
      loading: false,
      showModal: false,
      allowDelete: false,
    };
  }

  getAnexoURL(instance: AnexoObject) {
    this.setState({loading: true});
    fb.files.ref().child(instance.fileName).getDownloadURL()
      .then(url => {
        debug('getAnexoURL', url);
        if (!has(instance, 'rev') || instance.rev === 1) {
          fetch(url).then(res => res.text()).then(data => {
            this.setState({loading: false, anexoURL: `data:image/jpg;base64, ${data}`});
          });
        } else {
          this.setState({loading: false, anexoURL: url});
        }
      })
      .catch(erro => {
        console.error('Erro acessando imagem', erro);
        this.setState({loading: false});
      });
  }

  componentDidMount() {
    this.getAnexoURL(this.props.instance);
    this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    // reset
    if (prevProps.instance.id !== this.props.instance.id) {
      this.setState({
        loading: false,
        anexoURL: undefined,
        allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate()),
      });
    }

    // download URL
    if (!this.state.anexoURL && !this.state.loading) {
      this.getAnexoURL(this.props.instance);
    }
  }

  onDelete = () => {
    fb.db.collection('anexos').doc(this.props.instance.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Anexo excluído com sucesso.'));
        this.props.goBack();
      });
  };

  onClickAbrir = () => {
    if (this.state.anexoURL) {
      if (this.props.instance.tipo === 'image') {
        this.setState({showModal: true});
      } else {
        Browser.open({url: this.state.anexoURL});
      }
    }
  }

  render() {
    const {instance} = this.props;

    if (this.props.loading)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <EntityView
        instance={instance}
        ModelForm={FormAnexo}
        entityLabel="Anexo"
        gender="m"
        onDelete={this.onDelete}
        allowDelete={this.state.allowDelete}
        allowEdit={false}
        classname=""
      >
        <div>
          <div className="flex">
            <div className="w-1/2">
              <FieldView label={formDef.data.label} type="date"
                         value={instance.data} className="text-xl"/>
            </div>
          </div>

          <FieldView label="Referente a" value={instance.principal.label}/>
          <FieldView label={formDef.descricao.label} value={instance.descricao}
                     className="font-bold"/>
          {instance.name &&
            <FieldView label="Nome do arquivo" value={instance.name}/>
          }

          {instance.notas &&
            <FieldView label={formDef.notas.label} type="text" value={instance.notas}
                       className="text-gray-600"/>
          }

          {this.state.loading &&
            <IonProgressBar type="indeterminate"/>
          }
          {instance.tipo === 'image' && this.state.anexoURL &&
            <div
              className="mt-8 flex justify-center cursor-pointer"
              onClick={this.onClickAbrir}
            >

                <img
                  src={this.state.anexoURL}
                  alt="imagem"
                  className="object-contain max-h-72"
                />

            </div>
          }
        </div>
        <div className="mt-4 flex justify-center">
          <IonButton
            className="w-full md:w-1/3"
            onClick={this.onClickAbrir}
            disabled={!this.state.anexoURL}
          >
            {instance.tipo === 'image' ? 'Abrir imagem' : 'Abrir documento'}
          </IonButton>
        </div>

        {this.state.showModal && this.state.anexoURL &&
          <Lightbox
            mainSrc={this.state.anexoURL}
            onCloseRequest={() => this.setState({showModal: false})}
            imageTitle={instance.name || undefined}
          />
        }
      </EntityView>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaAnexo);